import React, { useCallback, useState } from 'react';

import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';
import Link from 'buyside/components/presentation/Link/link';
import Modal from 'buyside/components/presentation/Modal/modal';
import SubmitResearchButton from 'buyside/components/presentation/Button/SubmitResearchButton/submitResearchButton';

import styles from './accessModalStyles.scss';

const AccessModal = ({ title, accessData }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  let modalButtonText;
  const { type } = accessData;
  if (type === 'paladin') {
    modalButtonText = accessData.quota;
  } else if (type === 'product') {
    const daysRemainingText = accessData.daysRemaining
      ? accessData.daysRemaining.replace('Unlimited', '∞')
      : 'n/a';
    const daysText = daysRemainingText === '1' ? 'day' : 'days';
    modalButtonText = daysRemainingText === '0' ? 'Activate' : `${daysRemainingText} ${daysText}`;
  }

  let contentText;
  if (accessData.quotaDeadline) {
    contentText = (
      <div>
        As a paladin, you have
        <em> unlimited</em> access to SumZero so long as you fulfill your quotas by
        <strong> {accessData.quotaDeadline}</strong>
      </div>
    );
  } else {
    contentText = (
      <div>
        <p>
          You have <strong> {accessData.daysRemaining}</strong>{' '}
          {Number(accessData.daysRemaining) === 1 ? 'day' : 'days'} of access to the{' '}
          {title.toLowerCase()} database remaining.
        </p>
        <p>Your SumZero access is calculated from a variety of factors.</p>
        <p>
          If you have any questions, please contact{' '}
          <Link to="mailto:access@sumzero.com">access@sumzero.com</Link>.
        </p>
      </div>
    );
  }

  const renderOpenModalButton = useCallback(
    () => (
      <Button
        className={styles.accessModalButton}
        onClick={() => setIsModalOpen(true)}
        text={modalButtonText}
        type={BUTTON_TYPES.LINK}
      />
    ),
    [modalButtonText]
  );

  return (
    <Modal
      isOpen={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      renderOpenModalButton={renderOpenModalButton}
      size="sm"
      title="Access Info"
    >
      <div>
        {contentText}
        {title === 'Research' && (
          <div className={styles.accessModalFooter}>
            <SubmitResearchButton />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default AccessModal;
